import type { EmissionsAggregated } from 'walden-fast/types/fast-backend/emissions-aggregated';
import type { Factory } from 'walden-fast/types/mocks';

const MOCK_EMISSIONS_AGGREGATED: EmissionsAggregated = {
  totalNumberOfShipments: {
    monthToDate: 7,
    yearToDate: 83,
  },
  totalCo2Tonnes: {
    monthToDate: 27,
    yearToDate: 762,
  },
  totalDistance: {
    monthToDate: 37,
    yearToDate: 711,
  },
};

export const emissionsAggregatedFactory: Factory<EmissionsAggregated> = (
  overrides,
) => ({
  ...MOCK_EMISSIONS_AGGREGATED,
  ...overrides,
});
